<template>
    <fragment v-if="help_visibility">
        <a v-if="!inExtraDiv"
            class=""
           data-toggle="modal"
           :style="{'margin-top':top +'px', 'position':position, 'right':right+'px'}"
            data-placement="top"
           :title="__('help_and_information')"
            @click.prevent="openModal"
            :data-original-title="__('help_and_information')">
                <i class="fas fa-info-circle" :style="{color:color}">
                </i>
        </a>
        <div v-else-if="inExtraDiv"
            class="pull-right help-icon helper-btn d-flex">
                <a
                    class="tooltip-more"
                    data-toggle="modal"
                    data-placement="top"
                    :title="__('help_and_information')"
                    style="color:white;"
                    @click.prevent="openModal"
                    :data-original-title="__('help_and_information')">
                        <i class="fas fa-info-circle">
                        </i>
                </a>
        </div>
    </fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import events from './../../services/Events.js';

export default {
    name: 'button-open-help-modal',
    props: {
        'helpName' : {
            type: String,
            default: null
        },
        'inExtraDiv' : {
            type: Boolean,
            default: true
        },
        'color' : {
            type: String,
            default: 'white'
        },
        left:{
            type: Number,
            default:0,
        },
        top:{
            type: Number,
            default:0,
        },
        right:{
            type: Number,
            default:0,
        },
        position:{
            type: String,
            default:'',
        },

    },
    components: {
        Fragment
    },
    data : () => ({
        show_help_route : '/admin/help/show-help',
        help_visibility : false
    }),
    watch : {
        helpName (value, old) {
             this.getHelpVisibility(value);
        }
    },
    methods: {
        openModal() {
            events.$emit('showHelpModal', this.helpName);
        },
        getHelpVisibility (helpName) {
            if(helpName == null)
                return;

            this.axios.get(
                this.show_help_route,
                {
                    params : {
                        'helpName' : helpName
                }
            })
            .then( res => {
                this.help_visibility = res.data.help_visibility;
            }).catch( error => {
                console.log(error)
            })
        }
    },
    mounted: function () {
        this.getHelpVisibility(this.helpName)
    },

}
</script>
<style scoped>
 .ibox i {
     color: #fff;
     font-size: 11px;
 }

.modal-header a {
    align-self: center;
}

.modal-header i {
     color: #495966;
     font-size: 16px;
     margin-left: 3px;
 }
</style>
